// package imports
import { Card, Col, Row } from 'react-bootstrap';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

// project imports
import './pasa-proposer-details-card.css'
import setCookie from 'utils/journeyIdCookie/setJourneyId';
import AuthStore from 'modules/login/store/AuthStore';
import StorageKeys from 'constants/StorageKeys';
import pasaCampaignStore from '../pasa-campaign/pasa-campaign-store';
import * as APITypes from "../../../../constants/API"
import axios from 'axios';
import QmsSolutionStatus from 'constants/QmsSolutionStatus';
import PasaProductCard from '../pasa-product-card/PasaProductCard';
import QmsStorageKeys from 'constants/QmsStorageKeys';
import { toJS } from 'mobx';

const PasaProposerDetailsCard = (props) => {

  const { proposerData } = props
  const history = useHistory()
  let sourceFrom = toJS(AuthStore.sourceFrom)

  const onEditQuoteClick = async (u2JourneyId, pasaAvailable, maxUpsellValue) => {
    setCookie("journeyId", u2JourneyId);
    if (pasaAvailable === "Yes" || pasaAvailable === "yes") {
      sessionStorage.setItem(StorageKeys.IS_PASA_PRODUCT, true)
      sessionStorage.setItem(StorageKeys.SHOW_PASA, true)
      sessionStorage.setItem(StorageKeys.MAX_UPSELL_VALUE, maxUpsellValue)
    } else {
      sessionStorage.setItem(StorageKeys.IS_PASA_PRODUCT, false)
      sessionStorage.setItem(StorageKeys.SHOW_PASA, false)
      sessionStorage.setItem(StorageKeys.MAX_UPSELL_VALUE, "")
    }
    await AuthStore.fetchAllData(u2JourneyId)
    history.push({ pathname: "/customization" })
  }

  const shareOnwhatsApp = async (solutionId, journey_id) => {
    let reqObj = { "solution_id": solutionId }
    let response = await axios.post(APITypes.WHATSAPP_SHARE_CAMPAIGN, reqObj)
    if (response?.status === "success") {
      const url = `https://api.whatsapp.com/send?phone=${response?.data?.mobile_number}&text=${encodeURIComponent(response?.data?.whatsapp_message)}`
      window.open(url, '_blank', 'noopener,noreferrer');
    }
    pasaCampaignStore.saveCardStatus(journey_id)
  };

  const onStartApplicationClickB1 = async (solutionId, proposerId, journeyId, productData) => {
    setCookie("journeyId", journeyId);
    pasaCampaignStore.saveCardStatus(journeyId)

    let quotationStatusFormObj = document.getElementById(`quotation-status-form-post-call-uniqueId-${productData.application_number}`);
    console.log("quotationStatusFormObj formObj :: ", quotationStatusFormObj);
    quotationStatusFormObj.submit();

  }


  const onStartApplicationClickB2 = async (solutionId, proposerId, journeyId) => {
    setCookie("journeyId", journeyId);
    pasaCampaignStore.saveCardStatus(journeyId)
    let fetchDocumentList = await pasaCampaignStore.fetchDocumentList(solutionId)
    if (fetchDocumentList.data.length > 0) {
      localStorage.setItem("solutionList", solutionId);
      pasaCampaignStore.setshowDocumentList(true)
      pasaCampaignStore.setDocumentList(fetchDocumentList.data)
      pasaCampaignStore.productCardUniqueId = solutionId
    } else {
      // let responseData = await axios.post(APITypes.SAVE_SOLUCTION_STATUS, { proposer_id: proposerId, status: "application_started" })
      const requestObj = {
        "solution_list": [solutionId],
        "default_email": [],
        "optional_email": "",
        "share_optional_email": false
      }
      let response = await axios.post(APITypes.SEND_PDF, requestObj)
      let quotationStatusFormObj = document.getElementById(`pragati-out-oubound-form-post-call-uniqueId-${solutionId}`);
      console.log("quotationStatusFormObj formObj :: ", quotationStatusFormObj);
      quotationStatusFormObj.submit();

      // let quotationStatusFormObj = document.getElementById(`quotation-status-form-post-call-uniqueId-${productData.application_number}`);
      // console.log("quotationStatusFormObj formObj :: ", quotationStatusFormObj);
      // quotationStatusFormObj.submit();

    }


  }

  const onViewDetailsClick = async (proposer_data, status, journey_id) => {
    setCookie("journeyId", journey_id);
    pasaCampaignStore.saveCardStatus(journey_id)
    localStorage.setItem(StorageKeys.SOURCE_FROM, "NA")
    switch (status) {
      case QmsSolutionStatus.ANALYSIS_IN_PROGRESS:
        await onEditQuoteClick(journey_id, proposer_data.pasa_available, proposer_data?.max_upsell_value)
        break;

      case QmsSolutionStatus.QUOTE_SHARED:


        if (proposer_data?.pasa_available === "Yes" || proposer_data?.pasa_available === "yes") {
          sessionStorage.setItem(StorageKeys.IS_PASA_PRODUCT, true)
          sessionStorage.setItem(StorageKeys.SHOW_PASA, true)
        } else {
          sessionStorage.setItem(StorageKeys.IS_PASA_PRODUCT, false)
          sessionStorage.setItem(StorageKeys.SHOW_PASA, false)
        }

        history.push("/qms/qms-details", {
          proposerId: proposer_data?.proposer_id,
          journeyId: journey_id,
        });

        break;
      default:
        break;
    }

  }

  const fetchPdfUrl = async (proposerData, journeyId, sourceFrom) => {
    pasaCampaignStore.saveCardStatus(journeyId)

    let response = await axios.post(APITypes.FETCH_SOLUTION_PDF_FROM_DMS,
      {
        "dms_id": proposerData?.dms_id
      });

    if (response.status === "success") {
      let proposerName = proposerData?.proposer_name
      downloadQuotePdf(response.data.pdf_url, proposerName, proposerData.solution_id, sourceFrom)
    }
  }

  const downloadQuotePdf = (url, proposerName, solutionId, sourceFrom) => {
    if (sourceFrom === "Distribution_App") {
      window.open(url, "_blank");
    } else {
      fetch(url).then(r => r.blob()).then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `ELI Solution Presentation (${proposerName}) – ${solutionId}.pdf`,
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      });
    }
  }

  return (
    <>
      <div className={`pasa-proposer-details-card ml-3  ml-md-0  mb-md-0`}>
        <>
          <Row>
            <Col xs='12' className='pr-0'>
              <Card className='shadow py-0'>
                <Card.Body>
                  {proposerData.solution_list.map((data, index) =>
                    <>
                      <Row className='align-items-center'>
                        <Col className='pasa-col-2 text-center border-column px-4' >
                          <Row className='my-1'>
                            <p className='font-size-12 mb-0 text-primary'>Proposer Name</p>
                            <div className='border my-1 w-100 font-size-13'>{data.proposer_name}</div>
                          </Row>

                          <Row className='my-1'>
                            <p className='font-size-12 mb-0 text-primary'>Mobile No.</p>
                            <div className='border my-1 w-100 font-size-13'>{data.proposer_id}</div>
                          </Row>
                        </Col>

                        <Col className='pasa-col-2 text-center border-column px-4' >
                          <Row className='my-1'>
                            <p className='font-size-12 mb-0 text-primary'>Existing Product</p>
                            <div className='border my-1 w-100 font-size-13'>{data.existing_product}</div>
                          </Row>
                          <Row className='my-1'>
                            <p className='font-size-12 mb-0 text-primary'>Total Bonus Vested till FY24</p>
                            <div className='border my-1 w-100 font-size-13'>{global.toINR(data.existing_you_get)}</div>
                          </Row>
                        </Col>

                        <Col className='pasa-col-2 text-center border-column px-4' >
                          <Row className='my-1'>
                            <p className='font-size-12 mb-0 text-primary'>PASA Product</p>
                            <div className='border my-1 w-100 font-size-13'>
                              {data.default_new_product}
                            </div>
                          </Row>
                          <Row className='my-1'>
                            <p className='font-size-12 mb-0 text-primary'>Max Upsell Value</p>
                            <div className='border my-1 w-100 font-size-13'>{data.max_upsell_value}</div>
                          </Row>
                        </Col>
                        <PasaProductCard
                          productList={data?.product_names}
                          proposerData={data}
                          journeyId={proposerData?.journey_id}
                          setStartApplicationClick={onStartApplicationClickB1}
                        />
                        {data?.button_style?.solution_status_id != QmsSolutionStatus.APPLICATION_IN_PROGRESS &&
                          <>
                            <Col className=' pasa-col-2 text-center px-4 my-2' >
                              <Row className=''><div className={`border my-1 w-100 font-size-13 rounded pointer`} style={{ backgroundColor: data?.button_style?.button_color, color: data?.button_style?.button_text_color }} onClick={() => { onViewDetailsClick(data, data?.button_style?.solution_status_id, proposerData?.journey_id) }}>{data?.button_style?.button_text}</div></Row>
                              {(data?.button_style?.solution_status_id === QmsSolutionStatus.QUOTE_SHARED && data?.solution_id) &&
                                <Row className=''><div className={`border my-1 w-100 font-size-13 rounded bg-primary text-white pointer`} onClick={() => { onStartApplicationClickB2(data.solution_id, data?.proposer_id, proposerData?.journey_id) }}>Share PDF & Start Application</div></Row>
                              }

                              {data?.button_style?.solution_status_id === QmsSolutionStatus.QUOTE_SHARED &&
                                <>
                                  <Row className=''><div className='border my-1 w-100 font-size-13 bg-success text-white rounded pasa-share-wsp pointer' onClick={() => { shareOnwhatsApp(data?.solution_id, proposerData?.journey_id) }}>Share On Whatsapp</div></Row>
                                  <Row className=''><div className='border my-1 w-100 font-size-13 text-white rounded pasa-download-pdf pointer' onClick={() => fetchPdfUrl(data, proposerData?.journey_id, sourceFrom)} >{sourceFrom === "Distribution_App" ? "View Quote pdf" : "Download Quote pdf"}</div></Row>
                                </>
                              }
                            </Col>
                          </>
                        }

                        {data?.button_style?.solution_status_id === QmsSolutionStatus.APPLICATION_IN_PROGRESS &&
                          <Col className=' pasa-col-2 text-center px-4 my-2 d-none d-md-block' >
                            {data.product_names.map((item, index) =>
                              <>
                                <Row className=''><div className={`border my-1 w-100 font-size-13 rounded my-4`} style={{ backgroundColor: item?.button_color, color: item?.button_text_color }} onClick={() => { onStartApplicationClickB1(data.solution_id, data?.proposer_id, proposerData?.journey_id, item) }}>{item?.button_text}</div></Row>
                              </>
                            )}

                          </Col>
                        }

                      </Row>
                      {data?.solution_id &&
                        <div>
                          <form className='d-none' id={`pragati-out-oubound-form-post-call-uniqueId-${data?.solution_id}`} action={localStorage.getItem(QmsStorageKeys.START_APPLICATION_END_POINT_URL)} method={"POST"}>
                            <input type='text' name='Pragati_Token' value={sessionStorage.getItem(StorageKeys.AUTH_TOKEN)} />
                            <input type='text' name='LoginCode' value={localStorage.getItem(QmsStorageKeys.LOGIN_CODE)} />
                            <input type='text' name='Vendor' value={localStorage.getItem(QmsStorageKeys.VENDOR)} />
                            <input type='text' name='SourceFrom' value={"NA"} />
                            <input type='text' name='LoginAgentCode' value={localStorage.getItem(QmsStorageKeys.LOGIN_AGENT_CODE)} />
                            <input type='text' name='Solution_Id' value={data?.solution_id ? data.solution_id : ""} />
                            <input type='text' name='LA_Specific_Id' value={""} />
                            <input type='text' name='IsWebAppHeader' value={sourceFrom === "Distribution_App" ? 'N' : 'Y'} />
                            <button type='submit'>Submit</button>
                          </form>
                        </div>
                      }

                      {proposerData.solution_list.length !== index + 1 && (
                        <hr className='my-1' style={{ border: '2px solid black' }} ></hr>
                      )}
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      </div>
      <p className="m-0 text-danger pl-3 pl-md-1 pt-1 font-size-13">{`Expiring in ${proposerData?.expiring_day} Days`}</p>
    </>
  )
}
export default PasaProposerDetailsCard;